import CondicionalMercadoria from "@/modules/CondicionalMercadoria/pages/Index";
import CondicionalMercadoriaCreate from "@/modules/CondicionalMercadoria/pages/Create";

export default [
  {
    name: "condicionalMercadorias",
    path: "/condicional-mercadorias",
    component: CondicionalMercadoria,
    meta: {
      title: "Condicional de Mercadorias",
      permission: "condicional-mercadorias",
    },
  },
  {
    name: "condicionalMercadoriasNova",
    path: "/condicional-mercadorias/nova",
    component: CondicionalMercadoriaCreate,
    meta: {
      title: "Nova Condicional de Mercadorias",
      permission: "condicional-mercadorias",
    },
  },
  {
    name: "condicionalMercadoriasEditar",
    path: "/condicional-mercadorias/:id/editar",
    component: CondicionalMercadoriaCreate,
    meta: {
      title: "Editar Condicional de Mercadorias",
      permission: "condicional-mercadorias",
    },
  },
];
